import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { s3baseUrl } from "../../../config/config";
import Markdown from "markdown-to-jsx";
import { handleMarkdown, markDownLink } from "../../../utils/classRoomUtils";

function formatDuration(ms) {
  if (!ms) return "";
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export default function ParentMessage(props) {
  const { parentMessage, setParentMessage, containerClasses } = props;
  if (!parentMessage) return null;

  return (
    <div className={`message-reply-box ${containerClasses || ""}`}>
      {setParentMessage && (
        <div
          className="cross-reply-icon"
          onClick={() => setParentMessage(null)}
        >
          x
        </div>
      )}
      {parentMessage.recording_url && (
        <div className="message-reply-audio d-flex align-items-center gap-2">
          <Icon icon="fluent:mic-48-filled" className="message-reply-audio-icon" />
          <span className="message-reply-audio-label">
            Voice message
            {parentMessage.duration && (
              <span className="message-reply-audio-duration ms-1">
                ({formatDuration(parentMessage.duration)})
              </span>
            )}
          </span>
        </div>
      )}
      {parentMessage.message && (
        <div className="message-reply-text">
          <Markdown
            options={{
              overrides: {
                a: { component: markDownLink },
                p: { component: "div" },
              },
            }}
          >
            {handleMarkdown(parentMessage.message)}
          </Markdown>
        </div>
      )}
      {parentMessage.images?.length > 0 && (
        <div className="message-reply-images my-1">
          {parentMessage.images?.map((image) => {
            return (
              <a href={s3baseUrl + image} rel="noreferrer" target="_blank">
                <img src={s3baseUrl + image} alt="" loading="lazy" decoding="async" />
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
